module.exports = __webpack_public_path__ + "static/media/state_department_icon.7369cb05.svg";